export default __webpack_public_path__ + "images/aureth_79bf9b.svg";